import React from "react";
import Navbar from "../Navbar";

const Shipping = () => {
  return (
    <>
      <Navbar />

      <div className="main-about-container">
        <h1 style={{ color: "black" }}>Shipping and Refund</h1>
        <div
          style={{
            borderBottom: "2px solid red",
            margin: "auto",
            width: "8%",
            marginTop: "1rem",
          }}
        ></div>

        <div
          className="shipping-container"
          style={{
            textAlign: "left",
            fontSize: "1.5rem",
            fontWeight: "500",
            marginTop: "6rem",
            marginBottom:'3rem'
          }}
        >
          <div
            style={{
              width: "90%",
              margin: "auto",
              marginTop: "2rem",
              padding: "20px",
              border: "1px solid #ccc",
              borderRadius: "10px",
            }}
          >
            <h2 style={{ marginBottom: "1rem" }}>Shipping Policies</h2>
            <div
              style={{
                borderBottom: "2px solid red",
                width: "19%",
                marginTop: "1rem",
                marginBottom: "2rem",
                alignItems: "left",
              }}
            ></div>
            We strive to provide efficient shipping services to our valued
            customers. For any inquiries regarding shipping, please call us at
            7000697745. Our dedicated team is ready to assist you with any
            shipping- related questions or concerns.
          </div>

          <div
            style={{
              width: "90%",
              margin: "auto",
              marginTop: "2rem",
              padding: "20px",
              border: "1px solid #ccc",
              borderRadius: "10px",
            }}
          >
            <h2 style={{ marginBottom: "1rem" }}>Shipping Partners</h2>
            <div
              style={{
                borderBottom: "2px solid red",
                width: "19%",
                marginTop: "1rem",
                marginBottom: "2rem",
                alignItems: "left",
              }}
            ></div>
            We work with reliable and trusted delivery partners to ensure timely
            and secure shipments. Our shipping partners include [enter the names
            of your delivery partners here]. We have chosen these partners based
            on their reputation for safe and reliable delivery services.
          </div>

          <div
            style={{
              width: "90%",
              margin: "auto",
              marginTop: "2rem",
              padding: "20px",
              border: "1px solid #ccc",
              borderRadius: "10px",
            }}
          >
            <h2 style={{ marginBottom: "1rem" }}>Shipping/Delivery Time</h2>
            <div
              style={{
                borderBottom: "2px solid red",
                width: "19%",
                marginTop: "1rem",
                marginBottom: "2rem",
                alignItems: "left",
              }}
            ></div>
            We understand the importance of timely deliveries. If you place an
            order on a Sunday, you can expect delivery by Monday. For orders
            placed on any other day, we strive to ensure same-day delivery. If
            same-day delivery is not possible, your parcel will be delivered the
            next day. Please note that these delivery times are subject to
            factors such as product availability and location.
          </div>

          <div
            style={{
              width: "90%",
              margin: "auto",
              marginTop: "2rem",
              padding: "20px",
              border: "1px solid #ccc",
              borderRadius: "10px",
            }}
          >
            <h2 style={{ marginBottom: "1rem" }}>Guarantee and Warranty</h2>
            <div
              style={{
                borderBottom: "2px solid red",
                width: "19%",
                marginTop: "1rem",
                marginBottom: "2rem",
                alignItems: "left",
              }}
            ></div>
            We stand behind the quality of our products. All items come with a
            standard 20-day warranty. In case you receive a defective product,
            please notify us within this duration from the date of shipment. We
            will gladly replace or repair the damaged product at no cost to you,
            with shipping prepaid by us. If we are unable to provide a
            replacement due to stock unavailability, we will issue a 100%
            refund.
          </div>

          <div
            style={{
              width: "90%",
              margin: "auto",
              marginTop: "2rem",
              padding: "20px",
              border: "1px solid #ccc",
              borderRadius: "10px",
            }}
          >
            <h2 style={{ marginBottom: "1rem" }}>100% Refund / Replacement</h2>
            <div
              style={{
                borderBottom: "2px solid red",
                width: "19%",
                marginTop: "1rem",
                marginBottom: "2rem",
                alignItems: "left",
              }}
            ></div>
            We guarantee accurate descriptions and high-quality products as
            mentioned on our website. To protect customers from shipping damage,
            item mismatch, or missing parts, we provide a 2-day window (from the
            date of order delivery) to report any complaints. You can go to the
            "My Account" section, select your order, and request a refund. Our
            technical team will verify the details, and if approved, issue an
            RMA number for returning the material. Upon receiving the product,
            our experts will verify the reported issue and send replacement
            items with shipping costs prepaid by us. If replacement is not
            possible due to stock unavailability, we will issue a 100% refund.
            Please note that the warranty does not apply if the product has been
            misused, subjected to neglect, accident, modification, or altered in
            any way.
          </div>

          <div
            style={{
              width: "90%",
              margin: "auto",
              marginTop: "2rem",
              padding: "20px",
              border: "1px solid #ccc",
              borderRadius: "10px",
            }}
          >
            <h2 style={{ marginBottom: "1rem" }}>Cancelling an Order</h2>
            <div
              style={{
                borderBottom: "2px solid red",
                width: "19%",
                marginTop: "1rem",
                marginBottom: "2rem",
                alignItems: "left",
              }}
            ></div>
            If you wish to cancel your order or make changes to the shipping
            address, please email us your request. Our customer service team
            will respond within one business day regarding your request. Please
            note that only orders in the "Pending" or "Payment Verification"
            status can be altered or canceled. Once the order moves to a
            different status, it cannot be changed or canceled. Please be aware
            that order cancellation may attract 5% bank charges, depending on
            the payment method used. We are unable to offer order cancellation
            and returns without a valid reason, considering the nature of the
            products we sell and our strict quality policy. MACFOS LIMITED
            reserves the right to make the final decision on all refund
            requests.
          </div>

          <div
            style={{
              width: "90%",
              margin: "auto",
              marginTop: "2rem",
              padding: "20px",
              border: "1px solid #ccc",
              borderRadius: "10px",
            }}
          >
            <h2 style={{ marginBottom: "1rem" }}>Return Guidelines</h2>
            <div
              style={{
                borderBottom: "2px solid red",
                width: "19%",
                marginTop: "1rem",
                marginBottom: "2rem",
                alignItems: "left",
              }}
            ></div>
            In the case of a confirmed faulty item that cannot be repaired
            remotely, we will issue an RMA Number. Please clearly mention this
            number on the shipping boxes and avoid writing anything on the
            product packaging itself. Defective, unused merchandise will be
            replaced within 2 days of receipt. All returns must include a copy
            of the original packing list that came with your shipment.
          </div>
        </div>
      </div>
    </>
  );
};

export default Shipping;
